import { useModal } from '@application/utils';
import { SocialShareModal } from '@presentation/components';
import type { SocialShareButtonType } from '@presentation/components/SocialShareModal/types';
import type { FC } from 'react';
import { useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

const init: ReturnType<typeof useSocialShareModalSingleton> = {
  show: () => undefined,
  showFromClick: () => undefined,
  close: () => undefined,
  modal: {
    onCloseClick: undefined,
    open: false,
    position: [0, 0],
  },
  urls: undefined,
  setUrls: () => undefined,
};

const useSocialShareModalSingleton = () => {
  const modalHook = useModal({});
  const [urls, setUrls] = useState<Record<SocialShareButtonType, string>>();

  return { ...modalHook, urls, setUrls };
};

export const useSocialShareModal = singletonHook(init, useSocialShareModalSingleton);

export const SocialShareModalController: FC = () => {
  const { modal, urls } = useSocialShareModal();

  return <SocialShareModal modal={modal} urls={urls} />;
};
